/**
 * @file Обновление страницы после завершившейся загрузки.
 *
 * Квота обновляется один раз на задачу. Список обновляется только для папки
 * назначения, в том числе при неопределённом результате серверной сборки.
 */
import { useEffect, useRef } from 'react'

import { isUploadBusy } from './model'
import { useUpload } from './useUpload'

export function useUploadRefresh(
    boxId: string | undefined,
    folder: string,
    refreshFolder: () => void,
    refreshQuota: () => void,
) {
    const { state } = useUpload()
    const refreshed = useRef<string | null>(null)

    useEffect(() => {
        if (
            !state ||
            isUploadBusy(state) ||
            state.boxId !== boxId ||
            refreshed.current === state.id
        )
            return

        refreshed.current = state.id
        refreshQuota()
        if (
            state.folder === folder &&
            (state.phase === 'succeeded' || !state.retryable)
        )
            refreshFolder()
    }, [state, boxId, folder, refreshFolder, refreshQuota])
}
